import React from "react";

// Without this, any render-time throw unmounts the whole tree and the WebView
// shows a plain white page with nothing to debug from.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error("Render error:", error, info?.componentStack);
    }

    render() {
        if (this.state.error) {
            return (
                <div className="map_error">
                    <p>Something went wrong while drawing this layout.</p>
                    <code>{String(this.state.error?.message || this.state.error)}</code>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
